import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import useBodyScrollLock from '@vio/atlas/Overlay/useBodyScrollLock';
import { motion } from 'framer-motion';
import { getIsSearchBoxActive } from 'modules/searchBox/selectors';
import { closeSearchBox } from 'modules/searchBox/slice';
const _exp = /*#__PURE__*/() => motion.div;
const ShadowElement = /*#__PURE__*/styled(_exp())({
  name: "ShadowElement",
  class: "s1qg1x87",
  propsAsIs: true
});
const ANIMATION_DURATION = 0.2;
export const SearchBoxShadow: React.FC = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector(getIsSearchBoxActive);
  const ref = useRef<HTMLDivElement>();
  useBodyScrollLock({
    ref,
    isEnabled: isVisible
  });
  const closeOverlay = useCallback(() => {
    dispatch(closeSearchBox());
  }, [dispatch]);
  const handleClick = useCallback(() => {
    closeOverlay();
  }, [closeOverlay]);
  const onTouchMove = useCallback(() => {
    closeOverlay();
  }, [closeOverlay]);
  useEffect(() => {
    if (onTouchMove && isVisible && ref.current) {
      ref.current.addEventListener('touchmove', onTouchMove);
    }
    return () => {
      if (onTouchMove && isVisible && ref.current) {
        ref.current.removeEventListener('touchmove', onTouchMove);
      }
    };
  }, [isVisible, onTouchMove, ref]);
  return isVisible && <ShadowElement initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: ANIMATION_DURATION
  }} ref={ref} onClick={handleClick} />;
};

require("./SearchBoxShadow.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SearchBoxShadow.tsx");